export const myLeaveTranslationsEn = {
  MY_LEAVE_USER_REQUEST_PAGE_TITLE: "Details of leave request",
  MY_LEAVE_MY_LEAVE_REQUESTS_PAGE_TITLE: "My leave details and requests",
  MY_LEAVE_HANDLE_LEAVE_REQUESTS_PAGE_TITLE: "Details of leave requests",
  MY_LEAVE_NEW_LEAVE: "New leave",
  MY_LEAVE_ASSIGNER_GUIDE: "MyLeave assigner manual",
  MY_LEAVE_SAVE_FAILED: "The save was failed.",
  MY_LEAVE_SAVE_SUCCEEDED: "The save was successful.",
  MY_LEAVE_LEAVE_ASSIGN: "Leave assign",
  MY_LEAVE_SUCCESSFULLY_SAVED: "The data(s) have been successfully saved!",
  MY_LEAVE_EXPIRED_CONTRACT_ERROR: "The start or end date of the leave exceeds the end date of the definitive contract!",
  MY_LEAVE_NEXT_YEAR_BLOCKED_ERROR: "Requesting leave that extends into the following year or the following year is not permitted!",
  MY_LEAVE_INVALID_YEAR_ERROR: "Leave allocation is not possible for past years!",
  MY_LEAVE_REQUEST_HAS_BEEN_WITHDRAWN: "The request has since been withdrawn",
  MY_LEAVE_ENABLE_LEAVE_REQUESTS: "Employees' leave requests",
  MY_LEAVE_GRANT_LEAVE_TYPES: "Grant leave types",
  MY_LEAVE_ABBREVIATED_WORKDAYS: "W.days",
  MY_LEAVE_ABSENCE_WORK: "Remote work",
  MY_LEAVE_COUNT_OF_WORKDAYS: "Count of workdays",
  MY_LEAVE_FULFILLED_ABSENCE: "Fulfilled remote works",
  MY_LEAVE_LEAVE_AND_ABSENCE_REQUESTS: "Leave and remote work requests",
  MY_LEAVE_MY_FULFILLED_LEAVES_AND_ABSENCES: "My fulfilled leaves and remote works",
  MY_LEAVE_REQUESTS: "My requests",
  MY_LEAVE_MY_LEAVES_AND_ABSENCES: "My leaves and remote works",
  MY_LEAVE_SHOW_OTHER_ABSENCES: "Show remote works",
  MY_LEAVE_LEAVE_START: "Leave start",
  MY_LEAVE_LEAVE_END: "Leave end",
  MY_LEAVE_LEAVE_REQUESTS_HANDLE: "Close requests",
  MY_LEAVE_RECORDED_IN_JDOLBER: "Recorded in JDolBer",
  MY_LEAVE_COVERAGE_ERROR: "You already have submitted a request for this period!",
  MY_LEAVE_COVERAGE_ERROR_HOME_OFFICE: "You have already submitted a Home Office request for this period!",
  MY_LEAVE_COVERAGE_ERROR_LEAVE: "You have already submitted a leave request for this period!",
  MY_LEAVE_OVERLAP_ERROR: "Leave overlaps with absence!",
  MY_LEAVE_WORKDAYS_ERROR: "The count of work days must be greater tha 0!",
  MY_LEAVE_APPROVE_LEAVE_REQUEST_SUCCEEDED: "Approving leave request was a success!",
  MY_LEAVE_APPROVE_LEAVE_REQUEST_FAILED: "Approving leave request failed!",
  MY_LEAVE_REJECT_LEAVE_REQUEST_SUCCEEDED: "Rejecting was a success!",
  MY_LEAVE_REJECT_LEAVE_REQUEST_FAILED: "Rejecting leave request failed!",
  MY_LEAVE_SUBSEQUENT_REQUESTS: "Subsequent requests",
  MY_LEAVE_PAYROLL_EMAIL_INFO_TEXT:
    "An examiner can accept requests up to one month back in the current month. Open requests older than this can only be approved or rejected by a user with MyLeave Admin authority. If these requests are processed, the payroll should be notified to the email address provided above.",
  MY_LEAVE_PAYROLL_EMAIL_ADDRESS: "Payroll e-mail address",
  MY_LEAVE_LEAVES_AND_REMOTE_WORKS: "Leaves and remote works",
  MY_LEAVE_REVOKE_LEAVE_REQUEST: "Revoke leave request",
  MY_LEAVE_REVOKE_REMOTE_WORK_REQUEST: "Revoke remote work request",
  MY_LEAVE_REJECT_REQUEST: "Reject leave",
  MY_LEAVE_REJECT_REMOTE_WORK_REQUEST: "Reject remote work request",
  MY_LEAVE_REJECT_LEAVE_REQUEST_TEXT: "If you want to reject, you have to write a message to the employee!",
  MY_LEAVE_ADMINISTRATIVE_EMAIL: "Administrative email",
  MY_LEAVE_ADMINISTRATIVE_EMAIL_INFO_TEXT:
    "A copy of all emails related to the leave request (acceptance or rejection) will be sent to the Administrative email address provided above. With this solution, paper-based free array conduction can be triggered.",
  MY_LEAVE_MORE_DAYS_ERROR: "The requested days are more than available leave days!",
  MY_LEAVE_EFFECTIVE_WORK_DAY: "Working days according to contract:",
  MY_LEAVE_USER_GUIDE: "MyLeave user guide",
  MY_LEAVE_ADMIN_GUIDE: "MyLeave administrator guide",
  MY_LEAVE_EXAMINER_GUIDE: "MyLeave examiner guide",
  MY_LEAVE_VIEWER_GUIDE: "MyLeave viewer guide",
  MY_LEAVE_EFFECTIVE_WORK_DAY_INFO:
    "If the requested leave falls on a day where the number of daily working hours specified in the employment contract differs from the number of working hours according to the schedule, the number of days off will be determined based on the working hours according to the schedule.",
  MY_LEAVE_DAYS: "Days",
  MY_LEAVE_CONTRACT_WORKDAYS: "Contract workdays",
  MY_LEAVE_EFFECTIVE_WORKDAYS: "Effective workdays",
  MY_LEAVE_ENABLE_LEAVE_REQUESTS_INFO: "The employee is able to initiate a request for leave or remote work.",
  MY_LEAVE_SEPARATE_EMAIL_COMPANY: "Separate email for each company",
  MY_LEAVE_EXAMINER_CONTROL_PANEL: "Overview of leaves",
  MY_LEAVE_FULFILLED_BASE_LEAVE: "Fulfilled base leave",
  MY_LEAVE_EXAMINERS_CONTROL_PANEL: "Examiner view",
  MY_LEAVE_VIEWERS_CONTROL_PANEL: "Viewer view",
  MY_LEAVE_ASSIGNER_CONTROL_PANEL: "Assigner view",
  MY_LEAVE_NO_LEAVE: "There is no established leave",
  MY_LEAVE_CANCELLED_IN_JDOLBER: "Cancelled in JDolBer",
  MY_LEAVE_REQUESTABLE: "Requestable",
  MY_LEAVE_FULFILLED: "Fulfilled",
  MY_LEAVE_NEW_REQUEST: "New request",
  MY_LEAVE_NEW_LEAVE_BASE: "Base leave",
  MY_LEAVE_COVID_PLUS_10: "CovidPlus10 leave",
  MY_LEAVE_LEAVE_STUDY: "Study leave",
  MY_LEAVE_LEAVE_EMERGENCY: "Emergency leave",
  MY_LEAVE_LEAVE_ESZJTV: "ESZJTV leave",
  MY_LEAVE_LEAVE_SUMMARY: "Leave summary",
  MY_LEAVE_LEAVE_DETAILS: "Leave details",
  MY_LEAVE_MY_PREVIOUS_LEAVES: "My previous leaves",
  MY_LEAVE_Q: "COVID leave",
  MY_LEAVE_A: "Paternity leave",
  MY_LEAVE_B: "129.§ (2a) - prevented due to a long absence",
  MY_LEAVE_C: "289.§ (4) - maternity leave",
  MY_LEAVE_D: "ESZJTV leave",
  MY_LEAVE_E: "Left over from the previous year leave",
  MY_LEAVE_F: "Paid leave",
  MY_LEAVE_G: "Count of children leave",
  MY_LEAVE_H: "First marriage additional leave",
  MY_LEAVE_I: "Exhibition, conference, education",
  MY_LEAVE_J: "Work at an external location",
  MY_LEAVE_K: "Medical examination - MT.55.§",
  MY_LEAVE_L: "Availability time - MT.146.§(1)",
  MY_LEAVE_M: "Exemption from work - Mt.70.§(2)",
  MY_LEAVE_N: "Parental leave",
  MY_LEAVE_O: "Home office work",
  MY_LEAVE_P: "Exemption from work - Mt.55.§(1)",
  MY_LEAVE_R: "Extraordinary",
  MY_LEAVE_S: "Leave",
  MY_LEAVE_T: "Educational leave",
  MY_LEAVE_U: "Additional leave for grandparents",
  MY_LEAVE_V: "Emergency leave",
  MY_LEAVE_W: "Participation in professional events",
  MY_LEAVE_X: "Mandatory training",
  MY_LEAVE_Y: "Other professional event",
  MY_LEAVE_Z: "Preparation for the professional exam",
  MY_LEAVE_6: "Carer's leave",
  MY_LEAVE_7: "Chamber leave",
  MY_LEAVE_APPROVED: "Approved",
  MY_LEAVE_RECORDED: "Recorded",
  MY_LEAVE_ASSIGNED: "Assigned",
  MY_LEAVE_CANCELLED: "Cancelled",
  MY_LEAVE_REQUESTED: "Requested",
  MY_LEAVE_REJECTED: "Rejected",
  MY_LEAVE_INPROGRESS: "In progress",
  MY_LEAVE_BASELEAVEDAYS: "Base leave days",
  MY_LEAVE_ONAGE: "On age",
  MY_LEAVE_ONCOUNTOFCHILDREN: "On count of children",
  MY_LEAVE_ONSTUDY: "On study",
  MY_LEAVE_ONPREVIOUSYEAR: "On previous year",
  MY_LEAVE_ONCOVIDPLUS10: "CovidPlus10",
  MY_LEAVE_ONEXPOSEDTORADIATIONSTATE: "On exposed to radiation state",
  MY_LEAVE_ONDOUBLERISKSTATE: "On double risk state",
  MY_LEAVE_ONBLINDNESSSATE: "On healt damage",
  MY_LEAVE_ONJOBCLASS: "On job class",
  MY_LEAVE_ONJOBGRADE: "On job grade",
  MY_LEAVE_ONMANAGERSTATE: "On manager state",
  MY_LEAVE_ONPENSIONERSTATE: "On pensioner state",
  MY_LEAVE_ONTRAINERSTATE: "On trainer state",
  MY_LEAVE_ONYOUNGAGE: "On young age",
  MY_LEAVE_OTHER: "Other",
  MY_LEAVE_ONESZJTV19: "On law ESZJTV 19.§",
  MY_LEAVE_ONJOBYEARS: "On job years",
  MY_LEAVE_ONPREVIOUSYEARBASELEAVES: "On previous year base leaves (until 31.03.)",
  MY_LEAVE_ONAGE50YEARS: "On 50 years old age",
  MY_LEAVE_ONPREVIOUSYEARADDITIONALLEAVES: "On previous year additional leaves (until 30.06.)",
  MY_LEAVE_ONEMERGENCY: "Emergency leave - 12/31/2024",
  MY_LEAVE_NO_PERMISSION_FOR_ROLE_MESSAGE: "You do not have {{role}} permission for MyLeave",
  MY_LEAVE_NO_PERMISSION_FOR_ROLE: "You do not have permission for this operation",
  MY_LEAVE_NO_PERMISSION_FOR_CONTRACT: "You do not have permission for this employee",
  MY_LEAVE_ROLE_EXAMINER: "examiner",
  MY_LEAVE_ROLE_VIEWER: "viewer",
  MY_LEAVE_ROLE_ASSIGNER: "assigner",
  MY_LEAVE_PAST: "Past",
  MY_LEAVE_CURRENT: "Current",
  MY_LEAVE_FUTURE: "Future",
  MY_LEAVE_ENABLE_WEEKLY_REPEAT: "Enable weekly repeat",
  MY_LEAVE_SELECT_WEEKDAYS: "Select day(s):",
  MY_LEAVE_SELECT_AT_LEAST_ONE_DAY: "At least one day must be selected!",
  MY_LEAVE_REPEATED_START_DATE: "Recurring start date",
  MY_LEAVE_REPEATED_END_DATE: "Recurring end date",
  MY_LEAVE_REPEATED_HO_SAVE_SUCCEEDED: "{{count}} HomeOffice days successfully created",
  MY_LEAVE_MONTH_SPLIT_INFO: "Notice: The request spans multiple months. A separate leave record will be created for each month.",
};
